export const redirectTo = (link: string) => window.location.assign(link);
export const redirectToNewWindow = (link: string) =>
  window.open(link, "_blank");
